import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AppComponent } from '../app.component';
import { AuthService } from '../_services/auth.service';
import { DataService } from '../_services/data.service';
import { TokenStorageService } from '../_services/token-storage.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})

export class LoginComponent implements OnInit {

  mostrarError: boolean;
  mostrarErrorToken: boolean;
  formEnviando: Boolean;
  mensajeError!: string;
  loginForm = new FormGroup({
    usuario: new FormControl('', Validators.required),
    password: new FormControl('', Validators.required),
  });

  constructor(private activatedRoute: ActivatedRoute, private router: Router,
    private appComponent: AppComponent, private authService: AuthService,
    private tokenStorageService: TokenStorageService,
    private dataService:DataService) {
    this.formEnviando = false;
    this.mostrarError = false;
    this.mostrarErrorToken = false;
  }

  ngOnInit(): void {
    let tokenError = sessionStorage.getItem('tokenError');
    if (tokenError != null && tokenError === 'true') {
      this.mensajeError = "Sesión vencida, por favor inicie sesión nuevamente";
      this.mostrarError = true;
      sessionStorage.removeItem('tokenError');
    }
  }

  login() {
    this.formEnviando = true;
    this.mostrarError = false;
    let formObj = this.loginForm.getRawValue();
    this.authService.login(formObj.usuario, formObj.password).subscribe(usuario => {
      let roles:string[]=[];
      usuario.roles.forEach(el => {
        roles.push(el.denominacion);
      });
      this.tokenStorageService.saveRoles(roles);
     
      roles=this.tokenStorageService.getRoles();
      this.appComponent.showAdmin=roles.includes("ADMINISTRADOR");
      this.appComponent.showUser = roles.includes('AGENTE MATRICULADOR');
      this.formEnviando = false;
      this.tokenStorageService.saveToken(usuario.token);
      this.tokenStorageService.saveUser(usuario);
      const returnUrl = this.activatedRoute.snapshot.queryParams['returnUrl'] || '/';
      this.appComponent.isLoggedIn = true;
      this.appComponent.usuarioLogueado = usuario;
      this.router.navigate([returnUrl]);
    }, (error) => {
      this.mensajeError = error;
      this.mostrarError = true;
      this.formEnviando = false;
    });
  }
}
